import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import router from './router';
import { store } from '@/store/index';
import getPageTitle from '@/utils/page';
var asyncRouterFlag = 0;
var whiteList = ['login', 'init'];
router.beforeEach( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(to, from, next) {
    var token, asyncRouters;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          token = store.getters['user/token']; // 在白名单中的判断情况
          //修改网页标签名称
          document.title = getPageTitle(to.meta.title);
          if (!(whiteList.indexOf(to.name) > -1)) {
            _context.next = 6;
            break;
          }
          if (token) {
            next({
              name: store.getters["user/userInfo"].authority.defaultRouter
            });
          } else {
            next();
          }
          _context.next = 18;
          break;
        case 6:
          if (!token) {
            _context.next = 17;
            break;
          }
          if (!(!asyncRouterFlag && store.getters['router/asyncRouters'].length == 0)) {
            _context.next = 16;
            break;
          }
          asyncRouterFlag++;
          _context.next = 11;
          return store.dispatch('router/SetAsyncRouter');
        case 11:
          asyncRouters = store.getters['router/asyncRouters'];
          router.addRoutes(asyncRouters);
          next(_objectSpread(_objectSpread({}, to), {}, {
            replace: true
          }));
          _context.next = 17;
          break;
        case 16:
          next();
        case 17:
          // 不在白名单中并且未登陆的时候
          if (!token) {
            next({
              name: "login",
              query: {
                redirect: document.location.hash
              }
            });
          }
        case 18:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());